
import React from 'react';
import { observer } from 'mobx-react';
import dateFormat from 'dateformat';
import SimpleInput from './inputs/SimpleInput';
import SimpleTextarea from './inputs/SimpleTextarea';
import ReactSingleSelect from './inputs/ReactSingleSelect';
import ReactMultiSelectCluster from './inputs/ReactMultiSelectCluster';
import WidgetDateTimePicker from './inputs/WidgetDateTimePicker';

import 'react-select/dist/react-select.css';
import '../../assets/styles/PostForm.css'

export default observer(({ form }) => {        
    return (
        form.display ?
            <form className="form-post" onSubmit={form.onSubmit}>
                <div className="post-sublist-date">{dateFormat(new Date(), "mmm dd, yyyy")}</div>
                <div className="form-row wide">
                    <SimpleInput field={form.$('name')} />
                </div>
                <div className="form-row">                    
                    <SimpleTextarea field={form.$("url")} rows="1" />
                </div>
                <div className="form-row clusters">
                    <ReactMultiSelectCluster field={form.$('clusters')} />
                </div>
                <div className="form-row">
                    <WidgetDateTimePicker field={form.$('releasedate')} />
                </div>
                <div className="form-row">
                    <WidgetDateTimePicker field={form.$('expirydate')} />
                </div>
                <div className="form-row video-options">
                    <ReactSingleSelect field={form.$('enabled')} />
                    <ReactSingleSelect field={form.$('manageronly')} />
                </div>                

                <div className="form-controls">
                    <button
                        type="submit"
                        className="form-control-save"
                        onClick={form.onSubmit}
                    >{(form.submitting || form.validating)
                        ? <span className="fa-spinner fa-spin" />
                        : <span> Save</span>}</button>
                    <button
                        className="form-control-reset"
                        onClick={(...args) => {
                            form.onReset(...args);
                            form.display = false;
                        }}
                    ><span>Cancel</span></button>
                    <div className="form-error">
                        {form.error}
                    </div>

                </div>

                <p>{form.error}</p>
            </form> : ""
    )
});




// WEBPACK FOOTER //
// ./src/components/forms/FormVideo.jsx